// sizes / quality of the product gallery images (_imageGallery.jsx, core's client image). Core's server image
// defaults to quality 100 and sizes 100vw, the client one to quality 75 and "(max-width:768px)100vw,886px"; the
// gallery states its own values so the preload in the server HTML and the hydrated <img> ask for the same file.
export const GALLERY_QUALITY = 75;

// mobile: full-width slide
export const GALLERY_SIZES_MOBILE = "100vw";

// desktop: the gallery column is 32% of the container (max 1536px wide → ~480px)
export const GALLERY_SIZES_DESKTOP = "(min-width:1536px) 480px, 32vw";

// desktop thumbnails are 88×88
export const GALLERY_SIZES_THUMB = "88px";
